import Storage from 'good-storage'
import Config from '../config/app.js'

export function getAuthCode() {
    return Storage.session.get('authCode')
}

export function setAuthCode(value) {
    return Storage.session.set('authCode', value)
}
export function getStationId() {
    return Storage.session.get(Config.stationId)
}
export function getAgencyAppId() {
    return Storage.session.get(Config.agencyAppId)
}
export function getToken() {
    return Storage.session.get(Config.tokenKey)
}

export function setStationId(stationId) {
    return Storage.session.set(Config.stationId, stationId)
}
export function setAgencyAppId(agencyAppId) {
    return Storage.session.set(Config.agencyAppId, agencyAppId)
}
export function setToken(token) {
    return Storage.session.set(Config.tokenKey, token)
}
export function removeToken() {
    return Storage.session.remove(Config.tokenKey)
}

export function getRoleIdList() {
    return Storage.session.get('roleIdList')
}

export function setRoleIdList(roleIdList) {
    return Storage.session.set('roleIdList', roleIdList)
}

export function removeRoleIdList() {
    return Storage.session.remove('roleIdList')
}

export function isLogin() {
    return (getToken() || '').length > 5
}

export function hasPromission(code) {
    return true;
}

let cache = {};
export function cacheServerData(key, request) {
    var promise = new Promise((resolve, reject) => {
        var data = cache[key]
        if (data) resolve(data);
        else {
            request().then((d) => {
                cache[key] = d;
                data = d;
                resolve(data);
            }).catch(() => {
                reject()
            })
        }
    })
    return promise;
}